<div *ngIf="immersionChartData">
    <h4>Bookings</h4>
    <p-chart #chart type="line" [data]="immersionChartData" width="700px" height="500px"
    [responsive]="false"></p-chart>
    <div>
  <h4>
    Duration
  </h4>
            <p-chart #chart type="line" [data]="immersionDurationChartData" width="700px" height="500px"
                [responsive]="false"></p-chart>

    </div>
</div>